import { Field } from 'formik';
import { TextField } from 'formik-mui';

export const OkvedGroupForm = () => {

  return (
    <>
      <Field component={TextField} name="code" label="Код группы" placeholder="Код группы" required/>           
      <Field component={TextField} name="name" label="Наименование группы" required/>
    </>
  );
};
  

export default OkvedGroupForm;
